import SliderProgressBar from './SliderProgressBar'
export default SliderProgressBar
